import React, { useState, useEffect } from "react";
import CustomDropDown from "input/CustomDropDown";

const NewPlan = ({
    coachingPlanTrackOptions = null,
    name = null,
    selectedCoachingPlanTrack = null,
    timeZone = null,
    timeZoneOptions = null,
    // Callbacks
    onSetCoachingPlanTrack = null,
    onSetTimeZone = null,
    onStartNewPlan = null
}) => {

    const [init, SetInit] = useState(true);

    const handleSetTemplatePlan = (value) => {
        onSetCoachingPlanTrack(value);
    };

    const handleSetTimeZone = (value) => {
        onSetTimeZone(value);
    };

    useEffect(() => {
        if (init && coachingPlanTrackOptions && timeZoneOptions) {
            onSetCoachingPlanTrack(coachingPlanTrackOptions[0].value);
            onSetTimeZone(timeZoneOptions[0].value);
            SetInit(false);
        }
    }, [coachingPlanTrackOptions, timeZoneOptions]);

    return (
        <div className="w-full  p-6 flex-col justify-center items-center gap-y-9 inline-flex">
            <div className="self-stretch  flex-col justify-center items-center gap-y-5 flex">
                <div className="w-14 h-14 p-3.5 rounded-xl shadow border border-gray-200 justify-center items-center inline-flex">
                    <img className="w-7 h-7 relative flex-col justify-start items-start flex" src="/icons/calendar-plus-01.svg" alt="icon"/>
                </div>
                <div className="w-3/4 text-wrap  text-center text-gray-900 text-3xl font-semibold  ">
                    { `Set Up${name !== null ? ` ${name.split(" ")[0]}'s` : ""} Coaching Plan`}
                </div>
                <div className="w-3/4 text-wrap text-center text-gray-600 text-base font-normal">A coaching plan divides the Karuna program into 12 weeks of VET™ activity assignments, which you can customize to suit your patient’s needs. As you progress the plan, you can view usage data, monitor patient progress, and create outcome reports to document your patient’s recovery.</div>
            </div>
            <div className="flex-col justify-start items-start gap-2 flex">
                <div className="self-stretch flex-col justify-start items-start gap-1.5 flex">
                    <div className="text-gray-700 text-sm font-medium leading-tight">Coaching Plan Track</div>
                    {
                        coachingPlanTrackOptions && (
                            <CustomDropDown
                                defaultValue={selectedCoachingPlanTrack}
                                options={coachingPlanTrackOptions}
                                // Callbacks
                                onSelectionCallback={handleSetTemplatePlan}
                            />
                        )
                    }
                </div>
                <div className="self-stretch text-wrap text-slate-600 text-sm font-normal leading-tight">Start by selecting a template coaching plan based on the patient’s prescription.</div>
            </div>
            <div className=" flex-col justify-start items-start gap-2 flex">
                <div className="self-stretch  flex-col justify-start items-start gap-1.5 flex">
                    <div className="text-gray-700 text-sm font-medium  leading-tight">Patient Time Zone</div>
                    {
                        timeZoneOptions && (
                            <CustomDropDown
                                defaultValue={timeZone}
                                options={timeZoneOptions}
                                // Callbacks
                                onSelectionCallback={handleSetTimeZone}
                            />
                        )
                    }
                </div>
                <div className="invisible self-stretch text-wrap text-slate-600 text-sm font-normal leading-tight">
                    Start by selecting a template coaching plan based on the patient’s prescription.
                </div>
            </div>
            {
                (onStartNewPlan) && (
                    <button className="w-80 px-[18px] py-3 bg-brand-600 rounded-lg shadow border border-brand-600 hover:bg-brand-700 hover:border-brand-700 justify-center items-center gap-1.5 inline-flex cursor-pointer" onClick={onStartNewPlan}>
                        <div className="px-0.5 justify-center items-center flex">
                            <div className="text-white text-base font-semibold leading-normal">Create Plan</div>
                        </div>
                    </button>
                )
            }
        </div>
    );
};

export default NewPlan;
